import ToastContainers from "./Utils/ToastContainer";
import PageNotFound404 from "./Errors/PageNotFound404";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Base from "./Pages/Base";
import './App.css';
import Home from "./Pages/Home";
import ScrollToTop from "./Pages/include/ScrollToTop";
import React, { Suspense } from "react";
import AppBoot from "./Components/AppBoot";

const lazyWithRetry = (importFn) => {
  return React.lazy(() =>
    importFn().catch((error) => {
      console.error("Failed to load chunk, reloading page...", error);
      window.location.reload();
      return new Promise(() => {}); // Keep pending to avoid rendering crashes while reloading
    })
  );
};

const About = lazyWithRetry(() => import("./Pages/About"));
const Services = lazyWithRetry(() => import("./Pages/Services"));
const ServiceDetails = lazyWithRetry(() => import("./Pages/ServiceDetails"));
const Projects = lazyWithRetry(() => import("./Pages/Projects"));
const ProjectDetails = lazyWithRetry(() => import("./Pages/ProjectDetails"));
const Blogs = lazyWithRetry(() => import("./Pages/Blogs"));
const BlogDetails = lazyWithRetry(() => import("./Pages/BlogDetails"));
const Contact = lazyWithRetry(() => import("./Pages/Contact"));
const Gallery = lazyWithRetry(() => import("./Pages/Gallery"));

function App() {
  return (
    <AppBoot>
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ToastContainers />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Base><Home /></Base>} />
              <Route path="/about" element={<Base><About /></Base>} />
              <Route path="/gallery" element={<Base><Gallery /></Base>} />
              <Route path="/services" element={<Base><Services /></Base>} />
              <Route path="/services/:slug" element={<Base><ServiceDetails /></Base>} />
              <Route path="/projects" element={<Base><Projects /></Base>} />
              <Route path="/projects/:slug" element={<Base><ProjectDetails /></Base>} />
              <Route path="/blog" element={<Base><Blogs /></Base>} />
              <Route path="/blog/:slug" element={<Base><BlogDetails /></Base>} />
              <Route path="/contact" element={<Base><Contact /></Base>} />
              <Route path="*" element={<PageNotFound404 />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </LanguageProvider>
    </AppBoot>
  );
}

export default App;
